import { useGet, usePost } from '@/api/lib/integration';
import type { Action, LogAction, SubmitAction } from '@/api/actions/types';

export const getActions = useGet<void, Action[]>('/api/handlungen');

export const logAction = usePost<LogAction, void>('/api/handlungen/{actionId}/log');

export const submitAction = usePost<SubmitAction, Action>('/api/handlungen/{actionId}/submit');

